module.exports = __webpack_public_path__ + "static/media/Signup.844b9f9b.png";